/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/study-svt.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import {
    getFieldChangeItems,
    getProcessedFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const propArray = [
    'MinWinUnit',
    'MaxWinUnit',
    'MaxOccurrences',
    'Type',
    'MinOccurrences',
    'LeadVisitId',
    'IsEndDateEarliest',
    'CfId',
];

const StudySubjectVisitRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem, additionalInfo }: any) => {
    const refactoredOldItem = {
        ...oldItem,
        crfs:
            oldRecord?.EventIds && oldRecord?.EventIds.length
                ? oldRecord?.EventIds.map((item: any) => {
                      const element = additionalInfo?.crfs?.find((el: any) => el.id === item?.$oid);
                      if (element) return element;
                  }).filter((item: any) => item)
                : [],
    };
    const refactoredNewItem = {
        ...newItem,
        crfs:
            newRecord?.EventIds && newRecord?.EventIds.length
                ? newRecord?.EventIds.map((item: any) => {
                      const element = additionalInfo?.crfs?.find((el: any) => el.id === item?.$oid);
                      if (element) return element;
                  }).filter((item: any) => item)
                : [],
    };
    const refactoredOldRecord = {
        ...oldRecord,
        VisitType: oldRecord.Type,
        MinMaxUnit: oldRecord.MinWinUnit,
        NumberOccurrences: oldRecord.MinOccurrences,
        ...(oldRecord.IsEndDateEarliest !== undefined
            ? { EndDateUsage: oldRecord.IsEndDateEarliest ? 'Earliest' : 'Latest' }
            : {}),
        ...removePropertiesFromObject(oldRecord, propArray),
        CfId: oldRecord.CfId?.$oid,
    };

    const refactoredNewRecord = {
        ...newRecord,
        VisitType: newRecord.Type,
        MinMaxUnit: newRecord.MinWinUnit,
        NumberOccurrences: newRecord.MinOccurrences,
        ...(newRecord.IsEndDateEarliest !== undefined
            ? { EndDateUsage: newRecord.IsEndDateEarliest ? 'Earliest' : 'Latest' }
            : {}),
        ...removePropertiesFromObject(newRecord, propArray),
        CfId: newRecord.CfId?.$oid,
    };

    const enums: any = {
        LeadUnit: AuditEnumValues.StudyTimeUnit,
        MinMaxUnit: AuditEnumValues.StudyTimeUnit,
    };

    const isAssessmentsAssosiation = !!refactoredOldItem.assessments?.length || !!refactoredNewItem.assessments?.length;

    const associations: any = {
        EventIds: isAssessmentsAssosiation
            ? {
                  itemField: 'assessments',
                  name: 'Assessment',
                  nameResolver: (crfs: any) => crfs.name,
              }
            : {
                  itemField: 'crfs',
                  name: 'CRF',
                  nameResolver: (crfs: any) => crfs.crfName,
              },
        TreatmentArmIds: {
            itemField: 'treatmentArms',
            name: 'Treatment Arm',
            nameResolver: (arm: any) => arm.name,
        },
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem: refactoredOldItem,
            newItem: refactoredNewItem,
            field,
            enums,
            associations,
        }),
    );

    return <FieldChangeGrid items={items} />;
};
export { StudySubjectVisitRecordChangeGrid };
